import type { ApiModuleEndpoints } from '../types'

export const tableSessionApiEndpoints = {
  list: {
    method: 'GET',
    path: '/table-sessions',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/table-sessions/:id',
    requiresAuth: true,
  },
  open: {
    method: 'POST',
    path: '/table-sessions',
    requiresAuth: true,
  },
  calculate: {
    method: 'POST',
    path: '/table-sessions/:id/calculate-price',
    requiresAuth: true,
  },
  complete: {
    method: 'POST',
    path: '/table-sessions/:id/complete',
    requiresAuth: true,
  },
  cancel: {
    method: 'POST',
    path: '/table-sessions/:id/cancel',
    requiresAuth: true,
  },
  transfer: {
    method: 'POST',
    path: '/table-sessions/:id/transfer',
    requiresAuth: true,
  },
  adjustStartTime: {
    method: 'POST',
    path: '/table-sessions/:id/adjust-start-time',
    requiresAuth: true,
  },
  checkout: {
    method: 'POST',
    path: '/table-sessions/:id/checkout',
    requiresAuth: true,
  },
  syncPlayers: {
    method: 'PUT',
    path: '/table-sessions/:id/players',
    requiresAuth: true,
  },
  order: {
    method: 'GET',
    path: '/table-sessions/:id/order',
    requiresAuth: true,
  },
  saveOrder: {
    method: 'PUT',
    path: '/table-sessions/:id/order',
    requiresAuth: true,
  },
  productCatalog: {
    method: 'GET',
    path: '/table-sessions/:id/product-catalog',
    requiresAuth: true,
  },
  kitchenList: {
    method: 'GET',
    path: '/table-sessions/kitchen',
    requiresAuth: true,
  },
  kitchenCompleteItem: {
    method: 'POST',
    path: '/table-sessions/:id/order/items/:item/complete',
    requiresAuth: true,
  },
  kitchenReopenItem: {
    method: 'POST',
    path: '/table-sessions/:id/order/items/:item/reopen',
    requiresAuth: true,
  },
  kitchenCompleteOrder: {
    method: 'POST',
    path: '/table-sessions/:id/order/kitchen-complete',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
